module.exports = __webpack_public_path__ + "static/banner2-4c1f477372a63c4057b6645ad1d06365.jpg";